import { computed } from '@angular/core';
import { signalStoreFeature, type, withComputed } from '@ngrx/signals';
import { Bmi, BmiApi } from '@types-lib';
import { BmiStoreProps } from './bmi-store.model';

export function withBmiStoreComputed<_>() {
  return signalStoreFeature(
    {
      props: type<BmiStoreProps>(),
      state: type<Bmi.BmiStoreState>(),
    },
    withComputed(
      ({
        bmiListOptions: { filterBy, sort, pagination },
        bmiItemEntityMap,
        treatmentDetails,
        itemBeingEditedId,
        bmiItemEntities,
        _itemBeingEdited,
      }) => {
        return {
          itemBeingEdited: computed(() => _itemBeingEdited()),
          fullListLength: computed(() => bmiItemEntities().length),
          latestBmiItem: computed<BmiApi.UserBMI | null>(() =>
            bmiItemEntities()?.reduce((previous: BmiApi.UserBMI | null, current: BmiApi.UserBMI) => {
              if (previous?.created && current.created) {
                return new Date(previous.created) > new Date(current.created) ? previous : current;
              } else {
                return previous || current || null;
              }
            }, null),
          ),
        };
      },
    ),
  );
}
